import script from "./Leveringsmuligheder.vue?vue&type=script&setup=true&lang=js"
export * from "./Leveringsmuligheder.vue?vue&type=script&setup=true&lang=js"

import "./Leveringsmuligheder.vue?vue&type=style&index=0&id=6822ebcb&lang=css"

const __exports__ = script;

export default __exports__